import React from 'react';
import styled from 'styled-components';
import { TabMenu } from 'app.feature/academy/cbt.detail/screen/ScreenCbtDetail';

export type TabType = {
  id: number;
  name: string;
  size?: string;
  value: TabMenu;
  badge?: number;
};

type LineTabsProps = {
  data: TabType[];
  initialTab: TabType;
  fullWidth?: boolean;
  onChange: (value: TabMenu) => void;
  badge?: number;
};

const LineTabs: React.FC<LineTabsProps> = ({ data, initialTab, fullWidth, onChange }) => {
  const [activeTab, setActiveTab] = React.useState<TabType>(initialTab);

  const handleTabClick = (tab: TabType) => {
    setActiveTab(tab);
    onChange(tab.value);
  };

  return (
    <TabsWrapper fullWidth={fullWidth}>
      {data.map((tab) => (
        <Tab
          key={tab.id}
          isActive={tab.value === activeTab.value}
          onClick={() => handleTabClick(tab)}
          size={tab.size}
        >
          {tab.name}
          {tab.badge !== undefined && (
            <Badge isActive={tab.value === activeTab.value}>
              {tab.badge > 999 ? '999+' : tab.badge}
            </Badge>
          )}
        </Tab>
      ))}
    </TabsWrapper>
  );
};

export default LineTabs;

const TabsWrapper = styled.div<{ fullWidth?: boolean }>`
  display: flex;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  height: 60px;
  margin-bottom: 30px;
  align-items: center;
  * {
    box-sizing: border-box;
  }
`;

const Tab = styled.div<{ isActive: boolean; size?: string }>`
  flex: ${({ size }) => (size ? `0 0 ${size}` : '1')};

  height: 60px;
  flex-wrap: wrap;

  justify-content: center;
  align-items: center;
  line-height: 60px;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  color: ${({ isActive }) => (isActive ? '#01A0FF' : '#333')};
  border-bottom: ${({ isActive }) => (isActive ? '3px solid #01A0FF' : '1px solid #ddd')};
  font-weight: ${({ isActive }) => (isActive ? '600' : 400)};

  @media ${({ theme }) => theme.device.mobile} {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    font-size: 14px;
    word-break: auto-phrase;
    line-height: normal;
  }
`;

const Badge = styled.span<{ isActive: boolean }>`
  font-size: 15px;
  height: auto;
  max-height: 23px;
  padding: 0 10px;
  margin-left: 8px;
  color: ${({ isActive }) => (isActive ? '#01A0FF' : '#666')};
  border: ${({ isActive }) => (isActive ? '2px solid #D5EFFF' : '2px solid #ddd')};
  border-radius: 50px;
  background-color: ${({ isActive }) => (isActive ? '#F8FCFF' : '#FAFAFA')};
  @media ${({ theme }) => theme.device.mobile} {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    border: ${({ isActive }) => (isActive ? '1px solid #D5EFFF' : '1px solid #ddd')};
    border-radius: 10px;
    max-height: 20px;
    padding: 0 6px;
  }
`;
